const inputFieldMaxLength = {
    name: 50,
}

export default inputFieldMaxLength;
